export default class FilterStation {
    constructor(object) {
        this.code = object.code
        this.name = object.name
    }
}